import {Banner} from "../components/Banner"
import {Skills} from "../components/Skills"
import {Projects} from "../components/Projects"
import {Contact} from "../components/Contact"
import { StarTrackerFeature } from "../components/StarTrackerFeature";


const HomePage = () => {
    return(
        <>
            <Banner/>
            <Skills/>
            <Projects/>
            <StarTrackerFeature />
            <Contact/>
        </>
    )
}

export default HomePage